/* E340 Fun view (28.09.2026). Three short films about one doorbell, shown one at a time in the
   Fun tab (#cgk-v-simple). This file is the cinema: the poster picker, the shared helpers (window.CGF), the plain
   facts block and the toast. Each film is its own custom element in its own file, loaded on first play:
     <cgf-live>  cgau-e340f-live.js   Front Door, Live
     <cgf-ding>  cgau-e340f-ding.js   DING. (Subtitled)
     <cgf-knock> cgau-e340f-knock.js  Evening, I'm a Doorbell
   Silent. Nothing a film notices about the visitor leaves the browser. Deep links: #fun-live, #fun-ding, #fun-knock. */
(function () {
  "use strict";
  var HOST = document.getElementById("cgf");
  if (!HOST || HOST.shadowRoot) return;
  var A = HOST.dataset;
  var radio = document.getElementById("cgk-v-simple"), radioT = document.getElementById("cgk-v-tour");
  var PW = document.querySelector(".page-wrapper");
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function json(id) { try { return JSON.parse(document.getElementById(id).textContent); } catch (e) { return {}; } }
  var LIVE = json("cgk-live"), D = json("cgk-data");

  /* ---------- shared helpers ---------- */
  function header() { return parseFloat(getComputedStyle(document.body).getPropertyValue("--header-height")) || 0; }
  var subs = [];
  function onScroll(fn) { if (subs.indexOf(fn) < 0) subs.push(fn); }
  function offScroll(fn) { subs = subs.filter(function (f) { return f !== fn; }); }
  function fire() { for (var i = 0; i < subs.length; i++) { try { subs[i](); } catch (e) { if (window.console) console.error(e); } } }
  addEventListener("scroll", fire, { passive: true });
  if (PW) PW.addEventListener("scroll", fire, { passive: true });
  addEventListener("resize", fire);
  function scroller() { return PW && PW.scrollHeight > PW.clientHeight + 2 ? PW : (document.scrollingElement || document.documentElement); }
  function fonts(href) {
    if (document.querySelector('link[data-cgf-font="' + href + '"]')) return;
    var l = document.createElement("link"); l.rel = "stylesheet"; l.href = href; l.setAttribute("data-cgf-font", href); document.head.appendChild(l);
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/"; }
  function isOpen() { return !!(radio && radio.checked); }
  function addToCart(btn) {
    if (!LIVE.inStock) { toast("Sold out right now. The Simple view shows when it's back."); return Promise.resolve(false); }
    var theme = document.querySelector('product-form-component button[name="add"]');
    if (theme && !theme.disabled) { theme.click(); toast("Added. I'll keep an eye on it."); return Promise.resolve(true); }
    if (btn) btn.disabled = true;
    return fetch(root() + "cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: LIVE.variantId, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error(r.status); location.href = root() + "cart"; return true; })
      .catch(function () { if (btn) btn.disabled = false; toast("That didn't go through. Please use Add to cart at the top of the page."); return false; });
  }
  function toPlain() {
    if (!radioT) return;
    radioT.checked = true; radioT.dispatchEvent(new Event("change", { bubbles: true }));
    var c = document.querySelector(".cgk-choose"); if (c) c.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
  }
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add("on");
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove("on"); }, 3200);
  }
  /* scroll progress of a tall track whose stage sticks under the site header: 0 at the track's top, 1 at its end */
  function progress(track, stageH) {
    var r = track.getBoundingClientRect(), hh = header();
    var span = r.height - (stageH || (innerHeight - hh));
    if (span <= 0) return 0;
    return Math.min(1, Math.max(0, (hh - r.top) / span));
  }
  window.CGF = { A: A, LIVE: LIVE, D: D, reduce: reduce, header: header, onScroll: onScroll, offScroll: offScroll, scroller: scroller,
    fonts: fonts, addToCart: addToCart, toPlain: toPlain, toast: toast, isOpen: isOpen, progress: progress };

  /* ---------- the cinema ---------- */
  var FILMS = {
    live:  { tag: "cgf-live",  src: A.liveJs,  title: "Front Door, Live", tag2: "A thriller where you're the suspect.", rating: "M: mild surveillance" },
    ding:  { tag: "cgf-ding",  src: A.dingJs,  title: "DING. (Subtitled)", tag2: "A foreign film in fluent Doorbell.", rating: "PG: mild innuendo" },
    knock: { tag: "cgf-knock", src: A.knockJs, title: "Evening, I'm a Doorbell", tag2: "A door-to-door drama. The salesman is honest to a fault.", rating: "G: he records, he doesn't prevent" }
  };
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", "\"": "&quot;" }[c]; }); }
  var CSS = [
    ":host{display:block;--ink:#f5f5f7;--g1:#a1a1a6;--g2:#6e6e73;--bg:#0b0b0c;--line:rgba(255,255,255,.12);color:var(--ink);font-family:Inter,-apple-system,BlinkMacSystemFont,'Helvetica Neue',Arial,sans-serif;-webkit-font-smoothing:antialiased}",
    "*{box-sizing:border-box}",
    ".fun{background:var(--bg);border-radius:28px;overflow:clip;margin:0 auto 24px;max-width:1440px}",
    ".marquee{padding:34px 20px 22px;background:radial-gradient(120% 90% at 50% 0%,#1d1e24 0%,#0b0b0c 70%)}",
    ".k{margin:0 0 16px;font:600 12px/1.3 'Geist Mono',ui-monospace,Menlo,monospace;letter-spacing:.08em;text-transform:uppercase;color:#ffd60a;text-align:center}",
    ".k b{color:var(--ink);font-weight:600}",
    ".posters{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;max-width:1080px;margin:0 auto}",
    ".poster{all:unset;box-sizing:border-box;cursor:pointer;display:grid;grid-template-rows:auto auto 1fr auto;gap:6px;padding:10px 10px 14px;border-radius:18px;",
    "  background:#141417;box-shadow:inset 0 0 0 1px var(--line);transition:transform .25s cubic-bezier(.2,.8,.2,1),box-shadow .25s}",
    ".poster:hover{transform:translateY(-3px)}",
    ".poster:focus-visible{outline:3px solid #ffd60a;outline-offset:3px}",
    ".poster[aria-selected=true]{box-shadow:inset 0 0 0 2px #ffd60a,0 18px 40px -18px rgba(255,214,10,.45)}",
    ".art{display:block;aspect-ratio:16/10;border-radius:12px;background:#000 center/cover no-repeat;position:relative;overflow:hidden}",
    ".art-live::after{content:'\\25CF  LIVE';position:absolute;left:10px;top:9px;font:600 10px/1 'Geist Mono',ui-monospace,Menlo,monospace;letter-spacing:.08em;color:#fff;text-shadow:0 1px 3px #000}",
    ".art-live::before{content:'';position:absolute;left:30%;top:36%;width:28%;height:42%;border:1.5px solid #fff;border-radius:8px;box-shadow:0 0 0 1px rgba(0,0,0,.3)}",
    ".art-ding{display:grid;place-items:center;background:#000;color:#f5f5f0;font:800 clamp(28px,4.6vw,54px)/1 'Bricolage Grotesque',Inter,sans-serif;letter-spacing:-.02em}",
    ".art-ding::after{content:'[ding]';position:absolute;bottom:9px;left:0;right:0;text-align:center;font:600 11px/1 'IBM Plex Sans Condensed',Inter,sans-serif;color:#ffd60a}",
    ".art-knock{background:#0d0a07}",
    ".art-knock span{position:absolute;left:50%;top:50%;width:70%;aspect-ratio:1;transform:translate(-50%,-50%);border-radius:50%;background:center/cover no-repeat;box-shadow:0 0 0 5px #16100a,0 0 0 7px #3a2a18}",
    ".t{font:700 16px/1.2 Inter,sans-serif;letter-spacing:-.015em;color:var(--ink);margin-top:4px}",
    ".tag{font:400 13px/1.35 Inter,sans-serif;color:var(--g1)}",
    ".meta{font:600 10.5px/1.3 'Geist Mono',ui-monospace,Menlo,monospace;letter-spacing:.04em;color:var(--g2);text-transform:uppercase}",
    ".screen{position:relative;min-height:60vh}",
    ".loading{display:grid;place-items:center;min-height:60vh;color:var(--g1);font:500 14px/1.4 Inter,sans-serif}",
    ".plain{padding:40px 20px 34px;background:#f5f5f7;color:#1d1d1f}",
    ".plain .in{max-width:880px;margin:0 auto}",
    ".plain h3{margin:0 0 6px;font:700 28px/1.1 Inter,sans-serif;letter-spacing:-.03em}",
    ".plain h3 span{color:#86868b}",
    ".plain .sub{margin:0 0 18px;color:#6e6e73;font:400 15px/1.45 Inter,sans-serif}",
    ".plain ul{margin:0 0 18px;padding:0;list-style:none;display:grid;gap:10px}",
    ".plain li{padding:12px 14px;border-radius:12px;background:#fff;box-shadow:inset 0 0 0 1px #e8e8ed;font:400 15px/1.45 Inter,sans-serif}",
    ".plain p{margin:0 0 10px;font:400 14px/1.5 Inter,sans-serif;color:#424245}",
    ".plain p b{color:#1d1d1f}",
    ".plain .foot{margin-top:16px;font-size:12px;color:#86868b}",
    ".plain .row{display:flex;flex-wrap:wrap;gap:10px;margin:18px 0 6px}",
    ".btn{all:unset;box-sizing:border-box;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;min-height:46px;padding:0 20px;border-radius:980px;font:600 15px/1 Inter,sans-serif}",
    ".btn.go{background:#1d1d1f;color:#fff}.btn.ghost{box-shadow:inset 0 0 0 1px #d2d2d7;color:#1d1d1f;background:#fff}",
    ".btn:focus-visible{outline:3px solid #0066cc;outline-offset:2px}",
    ".toast{position:fixed;left:50%;bottom:22px;z-index:2147483000;transform:translate(-50%,20px);opacity:0;pointer-events:none;max-width:min(92vw,520px);",
    "  padding:12px 16px;border-radius:14px;background:#1d1d1f;color:#fff;font:500 14px/1.4 Inter,sans-serif;box-shadow:0 12px 30px rgba(0,0,0,.35);transition:opacity .25s,transform .25s}",
    ".toast.on{opacity:1;transform:translate(-50%,0)}",
    "@media (max-width:720px){.posters{grid-template-columns:minmax(0,1fr);gap:10px}.poster{grid-template-columns:120px minmax(0,1fr);grid-template-rows:auto auto auto;column-gap:12px;align-items:center}",
    "  .art{grid-row:1/4;aspect-ratio:1}.t{margin-top:0}.marquee{padding:26px 14px 16px}.fun{border-radius:22px}}",
    "@media (prefers-reduced-motion:reduce){.poster,.toast{transition:none}}"
  ].join("\n");

  function plainHTML() {
    var sv = (D.shortVersion || []).map(function (s) { return "<li>" + esc(s) + "</li>"; }).join("");
    return '<section class="plain" aria-label="The plain version"><div class="in">' +
      '<h3>The plain version. <span>No jokes.</span></h3>' +
      '<p class="sub">Everything the films joke about, said straight. The Simple view has the full specs.</p>' +
      "<ul>" + sv + "</ul>" +
      (D.condition ? "<p><b>Condition.</b> " + esc(D.condition) + "</p>" : "") +
      (D.warranty ? "<p><b>Warranty.</b> " + esc(D.warranty) + "</p>" : "") +
      (D.returns ? "<p><b>Returns.</b> " + esc(D.returns) + "</p>" : "") +
      (D.dispatch ? "<p><b>Dispatch.</b> " + esc(D.dispatch) + "</p>" : "") +
      (D.shipping ? "<p><b>Shipping.</b> " + esc(D.shipping) + "</p>" : "") +
      "<p><b>About the pictures.</b> The porch, doormat, shoe and peephole scenes in these films are AI-generated pictures, and the drawn and animated parts are illustrations, not camera footage. The doorbell itself is eufy's own product photo.</p>" +
      "<p>Details are believed accurate at time of listing.</p>" +
      '<div class="row"><button class="btn go" type="button" data-act="cart">Add to cart</button><button class="btn ghost" type="button" data-act="plain">Show the Simple view</button></div>' +
      (D.footer ? '<p class="foot">' + esc(D.footer) + "</p>" : "") +
      "</div></section>";
  }

  var sh = HOST.attachShadow({ mode: "open" });
  var posters = Object.keys(FILMS).map(function (k, i) {
    var f = FILMS[k], art = "";
    if (k === "live") art = '<span class="art art-live" style="background-image:url(\'' + esc(A.pov) + '\');background-position:50% 62%"></span>';
    if (k === "ding") art = '<span class="art art-ding">DING.</span>';
    if (k === "knock") art = '<span class="art art-knock"><span style="background-image:url(\'' + esc(A.peep) + '\')"></span></span>';
    return '<button class="poster" type="button" role="tab" id="p-' + k + '" data-film="' + k + '" aria-selected="' + (i === 0) + '" aria-controls="screen">' + art +
      '<span class="t">' + esc(f.title) + '</span><span class="tag">' + esc(f.tag2) + '</span><span class="meta">Rated ' + esc(f.rating) + " · about 2 min</span></button>";
  }).join("");
  sh.innerHTML = "<style>" + CSS + "</style>" +
    '<div class="fun"><header class="marquee"><p class="k">Now showing · <b>three short films about one doorbell</b></p>' +
    '<div class="posters" role="tablist" aria-label="Pick a film">' + posters + "</div></header>" +
    '<div class="screen" id="screen" role="tabpanel"></div>' + plainHTML() +
    '<div class="toast" id="toast" role="status" aria-live="polite"></div></div>';
  toastEl = sh.getElementById("toast");
  var screen = sh.getElementById("screen");
  fonts("https://fonts.googleapis.com/css2?family=Geist+Mono:wght@400;500;600&family=Bricolage+Grotesque:opsz,wdth,wght@12..96,75..100,300..800&family=IBM+Plex+Sans+Condensed:wght@500;600&display=swap");

  var loads = {}, current = null;
  function load(key) {
    var f = FILMS[key];
    if (customElements.get(f.tag)) return Promise.resolve();
    if (!loads[key]) loads[key] = new Promise(function (res, rej) {
      var s = document.createElement("script"); s.src = f.src; s.async = true;
      s.onload = function () { customElements.whenDefined(f.tag).then(res); };
      s.onerror = function () { loads[key] = null; rej(new Error("load " + key)); };
      document.head.appendChild(s);
    });
    return loads[key];
  }
  function play(key, scrollTo) {
    if (!FILMS[key]) key = "live";
    current = key;
    sh.querySelectorAll(".poster").forEach(function (b) { b.setAttribute("aria-selected", String(b.getAttribute("data-film") === key)); });
    screen.innerHTML = '<div class="loading">Rolling film…</div>';
    screen.setAttribute("aria-labelledby", "p-" + key);
    load(key).then(function () {
      if (current !== key) return;
      screen.innerHTML = "";
      screen.appendChild(document.createElement(FILMS[key].tag));
      fire();
      if (scrollTo) screen.scrollIntoView({ behavior: "auto", block: "start" });
    }).catch(function () {
      if (current === key) screen.innerHTML = '<div class="loading">This film didn\'t load. The Simple view has everything.</div>';
    });
  }
  sh.addEventListener("click", function (e) {
    var p = e.target.closest(".poster");
    if (p) { play(p.getAttribute("data-film"), true); return; }
    var b = e.target.closest("[data-act]");
    if (b && b.getAttribute("data-act") === "cart") addToCart(b);
    if (b && b.getAttribute("data-act") === "plain") toPlain();
  });
  sh.addEventListener("keydown", function (e) {
    var p = e.target.closest && e.target.closest(".poster"); if (!p || (e.key !== "ArrowRight" && e.key !== "ArrowLeft")) return;
    var keys = Object.keys(FILMS), i = keys.indexOf(p.getAttribute("data-film"));
    var n = keys[(i + (e.key === "ArrowRight" ? 1 : keys.length - 1)) % keys.length];
    sh.getElementById("p-" + n).focus(); play(n, false); e.preventDefault();
  });

  function open() {
    window.dispatchEvent(new CustomEvent("cgf:open", { detail: { open: isOpen() } }));
    if (isOpen() && !current) play("live", false);
    fire();
  }
  if (radio) radio.addEventListener("change", open);
  if (radioT) radioT.addEventListener("change", open);
  var m = /^#fun-(live|ding|knock)$/.exec(location.hash || "");
  if (m && radio) {
    radio.checked = true; radio.dispatchEvent(new Event("change", { bubbles: true }));
    play(m[1], true);
    setTimeout(function () { HOST.scrollIntoView({ behavior: "auto", block: "start" }); }, 60);
  } else if (isOpen()) open();
})();
